import { useCallback } from 'react';
import { Modal } from 'antd';

// Guards a modal/drawer close behind a discard confirmation when there is
// unsaved progress. Returns a `requestClose` handler to wire to every close
// path (Cancel button, X). When nothing is dirty it closes immediately without
// prompting.
const useConfirmClose = (isDirty: boolean, onClose: () => void): (() => void) =>
	useCallback(() => {
		if (!isDirty) {
			onClose();
			return;
		}
		Modal.confirm({
			title: 'Discard changes?',
			content: 'All progress will be discarded. Confirm?',
			okText: 'Discard changes',
			okType: 'danger',
			cancelText: 'Keep editing',
			onOk: onClose,
		});
	}, [isDirty, onClose]);

export default useConfirmClose;
